<template>
  <div class="recharge-nav-bar" :style="[{'background':bgTrans?'transparent':'#fff'}]">
    <div class="left" :style="{ color: fontColor}" @click="leftBack">
      <van-icon  v-if="!lefticonshow" name="arrow-left" :style="{ color: fontColor }" />
      <img v-else :src="lefticon" class="back_icon" alt="" />
    </div>
    <div class="title" :style="{ color: TextColor }">{{ titleText }}</div>
    <div class="right"  :style="{ color: fontColor }" @click="rightclick" v-show="righticonshow">
      <img v-show="righticon" :src="righticon" class="more_icon" alt="" />
      <p class="righttext" v-show="righttext" :style="righttextStyle">
        {{ righttext }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "navBar",
  data() {
    return {
      
    };
  },
  props: {
     righttextStyle: {
      type: Object,
      default: () => {
        return {};
      },
    },
    titleText: {
      type: String
    },
    rightText: {
      type: String
    },
    fontColor: {
      type: String,
      defult: "#ffffff",
    },
    TextColor:{
      type: String,
      defult: "#ffffff",
    },
    bgc: {
      type: String
    },
    bg: {
      type: String
    },
    isFixed: {
      type: Boolean,
      default: false,
    },
    righticon: {
      type: String,
      default: "",
    },
    lefticon:{
      type: String,
      default: "",
    },
    righticonshow: {
      type: Boolean,
      default: false,
    },
    lefticonshow:{
      type:Boolean,
      default:false,
    },
     righttext: {
      type: String,
      default: "",
    },
    titlestyle:{
      type:String,
      default:""
    },
    bgTrans:{
       type:Boolean,
      default:false,
    }
  },
  computed: {
    // style_bgc: function(){
    //   return {
    //     'background-color': this.bgc
    //   }
    // },
    // style_bg: function(){
    //   return {
    //     'background': this.bg
    //   }
    // },
    // style_fixed: function(){
    //   return this.isFixed ? {
    //     position: 'fixed',
    //     top: 0,
    //     'z-index': 100,
    //     padding: '31/5rem 0 8/5rem',
    //   } : {}
    // },
  },
  methods: {
    leftBack(){
      this.$emit('goBack')
    },
    rightclick(){
      this.$emit('rightclick')
    }
  },
};
</script>

<style scoped lang='less'>
.recharge-nav-bar {
  width: 100%;
  background: #fff;
  // height: 44/5rem;
  display: flex;
  align-items: center;
  padding: 4.4rem 0 0.6rem 0;
  .left {
    position: absolute;
    left: 0;
    // padding: 0 32/5rem;
    display: flex;
    align-items: center;
  }
  .van-icon{
    font-size: 2rem;
    padding-left: 0.3rem;
  }
  .title {
    width: 100%;
    height: 2.5rem;
    line-height: 2.5rem;
    text-align: center;
    font-size:1.7rem;
    font-weight:500;
  }
  .right {
    position: absolute;
    right: 0;
    padding: 0 0 0 1rem;
  }
}
.more_icon{
  width:1.8rem;
  padding:0.4rem 1rem 0.5rem 1rem;
}
.back_icon{
  width: 3.6rem;
  height: 2.4rem;
}
.titleIcon{
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>